import { type ISummaryItem } from "../../../../../../pages/Summary/Summary.types";
import { StyledTd } from "../../../../../../styled";
import { ReviewText } from "../../ReviewsTable.styled";
import { DateTimeDisp } from "src/components/shared/DateTime";

interface Props {
  row: ISummaryItem;
  disabled: boolean | undefined;
  red?: boolean;
}

const OpenedCell = ({ row, disabled, red }: Props) => {
  return (
    <StyledTd style={{ minWidth: 250 }} red={red}>
      <DateTimeDisp
        size="13px"
        color="blue"
        utc={row.datecreatedUTC}
        utcOffset={row.datecreatedOffset}
        lt={row.datecreated}
        disabled={disabled}
        containerProps={{ mb: 4 }}
      />
      <ReviewText fz="13px" blue disabled={disabled}>
        {`${row?.openrole || ""} ${row?.openby || ""}`}
      </ReviewText>
    </StyledTd>
  );
};
export default OpenedCell;
